module.exports = __webpack_public_path__ + "img/fa-solid-900.8c4a670.svg";